import React from 'react';
import { motion } from 'framer-motion';
import { CompassIcon, MegaphoneIcon, RadioIcon, HandshakeIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const SERVICES = [{
  icon: CompassIcon,
  title: 'Strategy',
  tagline: 'Growth strategies built around your business objectives.',
  items: ['Business Strategy', 'Market Entry', 'Brand Positioning', 'Market Research']
}, {
  icon: MegaphoneIcon,
  title: 'Communications',
  tagline: 'Building brands people trust.',
  items: ['Corporate Communications', 'Public Relations', 'Thought Leadership', 'Content Strategy']
}, {
  icon: RadioIcon,
  title: 'Media',
  tagline: 'Smarter media investments that deliver measurable performance.',
  items: ['Programmatic Advertising', 'Connected TV', 'Digital Campaigns', 'Audience Intelligence', 'Measurement']
}, {
  icon: HandshakeIcon,
  title: 'Partnerships',
  tagline: 'Connecting organizations with opportunities that matter.',
  items: ['Strategic Partnerships', 'Business Development', 'Stakeholder Engagement', 'Commercial Advisory']
}];
export function Services() {
  return <section id="services" className="w-full bg-navy py-24 md:py-32" data-id="element-128" data-mp="2x9ykvyftppi6">
      <div className="max-w-7xl mx-auto px-6" data-id="element-129" data-mp="32b4ctu1nt8qn">
        <SectionHeading eyebrow="What We Do" title="Four disciplines. One outcome." subtitle="Together, strategy, communications, media, and partnerships drive sustainable growth across African markets." align="center" variant="light" data-id="element-130" data-mp="3pzxca0hhpyq0" />

        <div className="mt-16 grid sm:grid-cols-2 gap-6" data-id="element-131" data-mp="3l13ye6yak5pb">
          {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return <motion.article key={s.title} initial={{
            opacity: 0,
            y: 28
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.08,
            ease: [0.22, 1, 0.36, 1]
          }} className="group relative bg-graphite/30 border border-ivory/10 rounded-2xl p-8 hover:border-gold/50 transition-colors" data-id="element-132" data-mp="24lswn1pk9idl" data-mpi={i}>
                <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-gold/10 text-gold mb-6 group-hover:bg-gold group-hover:text-navy transition-colors" data-id="element-133" data-mp="16tl596yd7s9k">
                  <Icon size={26} data-id="element-134" data-mp="11t6z5ugbqse6" />
                </div>
                <h3 className="font-serif text-3xl text-ivory" data-id="element-135" data-mp="xs4xl6yxq491">{s.title}</h3>
                <p className="mt-2 text-ivory/70" data-id="element-136" data-mp="su3dqjtoq0wi">{s.tagline}</p>
                <ul className="mt-6 flex flex-wrap gap-2" data-id="element-137" data-mp="svwlk2g1ar63">
                  {s.items.map(item => <li key={item} className="text-sm text-ivory/80 border border-ivory/15 rounded-full px-3 py-1.5" data-id="element-138" data-mp="2s4uyw9rmufqg">
                      {item}
                    </li>)}
                </ul>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}